import { Component, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { PreviewModelYComponent } from '../preview-model-y/preview-model-y.component'

@Component({
    selector: 'mg-interior-view-model-y',
    templateUrl: './interior-view-model-y.component.html',
    styleUrls: ['./interior-view-model-y.component.scss'],
})
export class InteriorViewModelYComponent {
    constructor(@Inject(MatDialogRef) public dialogRef: MatDialogRef<PreviewModelYComponent>) {}

    close(): void {
        this.dialogRef.close()
    }
}
